import { createFileRoute } from '@tanstack/react-router';
import { AgentsPage } from '../../screens/settings/Agents';

export const Route = createFileRoute('/settings/agents')({
  component: AgentsPage,
});
